import type { ReactNode } from 'react'

import { Button, type ButtonColor } from '../Button'
import { Heading } from '../Heading'

type EmptyStateProps = {
  heading: string
  subheading: string
  icon?: ReactNode
  buttonText?: string
  onButtonClick?: () => void
  buttonTo?: string
  buttonId?: string
  containerClasses?: string
  buttonColor?: ButtonColor
}

export const EmptyState = ({
  heading,
  subheading,
  icon,
  buttonText,
  onButtonClick,
  buttonTo,
  buttonId,
  containerClasses,
  buttonColor = 'primary',
}: EmptyStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center text-center py-12 px-4 ${containerClasses || ''}`}>
      {icon && (
        <div
          aria-hidden="true"
          className="mx-auto mb-4"
        >
          {icon}
        </div>
      )}
      <Heading level={3}>{heading}</Heading>
      <p className="text-sm mb-4 max-w-sm text-gray-500 dark:text-gray-400">{subheading}</p>
      {buttonText && (
        <div className="w-full md:w-auto">
          {buttonTo ? (
            <Button
              color={buttonColor}
              id={buttonId}
              to={buttonTo}
              data-testid={buttonId}
            >
              {buttonText}
            </Button>
          ) : (
            <Button
              color={buttonColor}
              id={buttonId}
              data-testid={buttonId}
              onClick={onButtonClick}
            >
              {buttonText}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
